import React, { useContext, useEffect, useState } from 'react';

import { Typography, Button } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

import { CartContext } from '../../store/CartContext';

import '../../components/Status.css';
import Basket from '../../components/checkout/Basket';
import DemoConsole from '../../components/demo-console/DemoConsole';

interface Props {}

const Success: React.FC<Props> = props => {
  const navigate = useNavigate();
  const { setCart } = useContext(CartContext);
  const [, setData] = useState<any[]>([]);
  const [state, setState] = useState<any>({});
  const [demoMessages, setDemoMessages] = useState<string[]>([]);

  useEffect(() => {
    if (window?.location.pathname.includes('demo')) {
      const messagess = localStorage.getItem('demoMessages');
      if (messagess) {
        setDemoMessages(JSON.parse(messagess));
      }
    }
  }, []);

  useEffect(() => {
    const res = localStorage.getItem('state');
    const order = localStorage.getItem('cart');
    res && setState(JSON.parse(res));
    order && setData(JSON.parse(order));

    return () => {
      setCart([]);
    };
  }, []);
  const date = new Date().toLocaleDateString();
  const time = new Date().toLocaleTimeString();

  const onButtonClick = () => {
    setCart([]);
    localStorage.removeItem('state');
    navigate(window?.location.pathname.includes('demo') ? '/demo' : '/');
  };

  const cardNumber = state?.cardNumber && state?.cardNumber.slice(-4);
  return (
    <div className="Checkout decline">
      <DemoConsole isShow={demoMessages.length > 0} messages={demoMessages} />

      <div className="Confirmation">
        <div className="content">
          <Typography variant="h4">Success</Typography>
          <Typography className="block-title">The payment has been successful</Typography>
        </div>
      </div>
      <div className="complete-container">
        <div className="client-info-box">
          <div className="block">
            <div className="block-title">Order information</div>
            <div className="block-text">Your order: C00904114153</div>
            <div className="block-text">
              Order date: {date}, {time}
            </div>
          </div>
          <div className="block">
            <div className="block-title">Billing address</div>
            <div className="block-text">
              {state.billingFirstName} {state.billingLastName}
            </div>
            <div className="block-text">{state.billingAddressLine1}</div>
            <div className="block-text">
              {state.billingCity}, {state.billingZip}, {state.billingCountry}
            </div>
            <div className="block-text">{state.email}</div>
            <div className="block-text">{state.phone}</div>
          </div>
          <div className="last-block">
            <div className="block-title">Payment</div>
            <div className="block-text">
              <div className="cart-image">
                <img src="/images/visa.png" width={30} alt="visa" />
              </div>
              <div>
                {cardNumber} Exp: {state?.expirationMonth}/{state?.expirationYear}
              </div>
            </div>
            <div className="block-text">{state.cardName}</div>
          </div>
        </div>
        <div className="order-info-box">
          <Basket />
        </div>
      </div>
      <div className="buttons">
        <Button variant="outlined" onClick={onButtonClick}>
          Back to home page
        </Button>
      </div>
    </div>
  );
};

export default Success;
